<div class="kt-content">
    <div class="kt-portlet" style="width: -webkit-fill-available;">
        <div class="container-fluid d-flex align-items-center p-5 mb-5" style="text-align: center">
            <div>
                <div class="wizard-progress">
                    <ng-container *ngFor="let state of states">
                        <div [class]="'step ' + state.state.abbrevations + ' ' + getClass(state.state.abbrevations, state.isCurrent)">
                            {{state.state.name}}
                            <div class="node"></div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <ng-container *ngIf="checkState()">
            <div class="order__not-complited">
                <span translation="Axilla.App.Webshop.App.OrderOverview.NotConfirmed" source="AxillaAppWebshop"></span>
            </div>
        </ng-container>
    </div>
</div>

<div class="kt-content distribution mt-2 d-flex justify-content-around" style="gap:10px" *ngIf="order">
    <div class="kt-portlet" style="width: -webkit-fill-available;">
        <div class="kt-portlet__body">
            <div class="custom-card-body tab-lines order-block">
                <div class="column">
                    <div><span><b>Order information:</b></span></div>
                    <div class="order-information">
                        <span>State: {{order.state.name}}</span>
                        <span>Creator name: {{order.creatorUserName}}</span>
                        <span>Creation time: {{getDate(order.creationTime)}}</span>
                        <span>Last modification time: {{getDate(order.lastModificationTime)}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="checkExternalOrderId()">
        <div class="kt-portlet" style="width: -webkit-fill-available;">
            <div class="kt-portlet__body">
                <div class="custom-card-body tab-lines order-block">
                    <div class="column">
                        <div>
                            <span><b>Delivery address:</b></span>
                        </div>
                        <div class="order-information">
                            <span>Legal name: {{order.deliveryLegalName}}</span>
                            <span>Contact name: {{order.deliveryContactName}}</span>
                            <span>{{order.deliveryAddress}} {{order.deliveryAddressHouseNumber}} {{order.deliveryAddressApartment}}</span>
                            <span>{{order.deliveryAddressCity}} {{order.deliveryAddressPostcode}}</span>
                            <span>{{order.deliveryAddressCountry}}</span>
                            <span>{{order.deliveryAddressComment}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="kt-portlet" style="width: -webkit-fill-available;">
            <div class="kt-portlet__body">
                <div class="custom-card-body tab-lines order-block">
                    <div class="column">
                        <div>
                            <span><b>Invoice address:</b></span>
                        </div>
                        <div class="order-information">
                            <span>Legal name: {{order.invoiceLegalName}}</span>
                            <span>Contact name: {{order.invoiceContactName}}</span>
                            <span>{{order.invoiceAddress}} {{order.invoiceAddressHouseNumber}} {{order.invoiceAddressApartment}}</span>
                            <span>{{order.invoiceAddressCity}} {{order.invoiceAddressPostcode}}</span>
                            <span>{{order.invoiceAddressCountry}}</span>
                            <span>{{order.invoiceAddressComment}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </ng-container>
</div>

<div class="kt-content distribution">
    <div class="kt-portlet">
        <div class="kt-portlet__body" style="padding:0px">
            <!--<div class="card">  -->
            <p-dataView #dv [value]="products" [paginator]="true" [rows]="rowsAmount" paginatorPosition="both" filterBy="title"
                        [lazy]="true" (onLazyLoad)="loadData($event)"
                        emptyMessage="{{noArticlesText}}"
                        [totalRecords]="recordsCount">
                <p-header>
                    <div class="ui-helper-clearfix">
                        <div class="p-grid">

                            <div class="p-col-12 p-md-4 filter-container">
                                <div style="position:relative">
                                    <input type="search" pInputText placeholder="Search by code" (input)="dv.filter($event.target.value)">
                                </div>
                            </div>
                        </div>
                    </div>
                </p-header>
                <ng-template let-product pTemplate="listItem">
                    <div class="p-col-12 list-item">
                        <div class="product-list-item list-card">
                            <div class="product-list-detail d-flex">
                                <div class="product-image">
                                    <img src="{{getImgUrl(product.code)}}" alt="Article picture" />
                                </div>
                                <div>
                                    <div class="product-name">{{product.title}}</div>
                                    <div class="product-description">{{product.code}}</div>
                                    <div class="product-description">{{product.description}}</div>
                                    <!--<p-rating [value]="5" [readonly]="false" [cancel]="false"></p-rating>-->
                                    <!--<i class="pi pi-tag product-category-icon"></i><span class="product-category">Category</span>-->
                                </div>
                            </div>
                            <div class="product-list-action">
                                <span class="product-price">{{product.price | currency:getCurrency():'symbol-narrow':'.2-2'}}</span>
                                <span class="product-badge quantity">
                                    Quantity: {{product.quantity}}
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-dataView>
        </div>
    </div>
</div>

